// DepartmentSlice.js
import { createSlice } from "@reduxjs/toolkit";

const departmentSlice = createSlice({
  name: "department",
  initialState: {
    department: {
      data: [],
      loading: false,
      error: null,
    },
  },
  reducers: {
    fetchDepartmentStart(state) {
      state.department.loading = true;
      state.department.error = null;
    },
    fetchDepartmentSuccess(state, action) {
      state.department.loading = false;
      state.department.data = action.payload;
    },
    fetchDepartmentFailure(state, action) {
      state.department.loading = false;
      state.department.error = action.payload;
    },
    addDepartmentStart(state) {
      state.department.loading = true;
      state.department.error = null;
    },
    addDepartmentSuccess(state, action) {
      state.department.loading = false;
      state.department.data = [...state.department.data, action.payload];
    },
    addDepartmentFailure(state, action) {
      state.department.loading = false;
      state.department.error = action.payload;
    },
    updateDepartmentStart(state) {
      state.department.loading = true;
      state.department.error = null;
    },
    updateDepartmentSuccess(state, action) {
      state.department.loading = false;
      state.department.data = state.department.data.map((department) =>
        department.id === action.payload.id ? action.payload : department
      );
    },
    updateDepartmentFailure(state, action) {
      state.department.loading = false;
      state.department.error = action.payload;
    },
    deleteDepartmentStart(state) {
      state.department.loading = true;
      state.department.error = null;
    },
    deleteDepartmentSuccess(state, action) {
      state.department.loading = false;
      state.department.data = state.department.data.filter(
        (department) => department.id !== action.payload
      );
    },
    deleteDepartmentFailure(state, action) {
      state.department.loading = false;
      state.department.error = action.payload;
    },
  },
});

export const {
  fetchDepartmentStart,
  fetchDepartmentSuccess,
  fetchDepartmentFailure,
  addDepartmentStart,
  addDepartmentSuccess,
  addDepartmentFailure,
  updateDepartmentStart,
  updateDepartmentSuccess,
  updateDepartmentFailure,
  deleteDepartmentStart,
  deleteDepartmentSuccess,
  deleteDepartmentFailure,
} = departmentSlice.actions;

export default departmentSlice.reducer;
